class Tooltip {
    constructor(element) {
        this.element = element;
        this.tip = element.getAttribute('data-tooltip');
        this.tooltip = null;
        this.icon = null;
        this.popup = null;
        this.active = false;

        this.init();
    }

    init() {
        this.render();
        this.listen();
    }

    render() {
        this.tooltip = document.createElement('div');
        this.tooltip.classList.add('syn-tooltip');
        
        this.icon = document.createElement('i');
        this.icon.classList.add('syn-tooltip__icon');
        this.icon.classList.add('icon');
        this.icon.classList.add('icon-question-mark');

        this.popup = document.createElement('span');
        this.popup.classList.add('syn-tooltip__popup');
        this.popup.textContent = this.tip;
        
        this.tooltip.appendChild(this.icon);
        this.tooltip.appendChild(this.popup);

        this.element.appendChild(this.tooltip);
    }

    listen() {
        this.icon.addEventListener('click', this.toggle.bind(this));
    }
    
    toggle() {
        if (this.active) {
            this.deactivate();
        } else {
            jQuery(document).trigger('syn_tooltip:close');
            this.activate();
        }
    }

    detectIfOffScreen() {
        const rect = this.tooltip.getBoundingClientRect();
        const popup = this.tooltip.querySelector('.syn-tooltip__popup');

        // if its going off to the left
        if (popup.offsetWidth > rect.left) {
            this.tooltip.classList.add('offset');
            this.tooltip.classList.add('offset--left');
        }

        if (rect.right + popup.offsetWidth > window.innerWidth) {
            this.tooltip.classList.add('offset');
            this.tooltip.classList.add('offset--right');
        }

        if (rect.top > popup.offsetHeight) {
            this.tooltip.classList.add('offset');
            this.tooltip.classList.add('offset--top');
        }

        if (rect.bottom + popup.offsetHeight > window.innerHeight) {
            this.tooltip.classList.add('offset');
            this.tooltip.classList.add('offset--bottom');
        }
    }
    
    activate() {
        this.detectIfOffScreen();
        this.tooltip.classList.add('is-active');
        this.active = true;
    }

    deactivate() {
        this.tooltip.classList.remove('offset');
        this.tooltip.classList.remove('offset--left');
        this.tooltip.classList.remove('offset--right');
        this.tooltip.classList.remove('offset--top');
        this.tooltip.classList.remove('offset--bottom');
        this.tooltip.classList.remove('is-active');
        this.active = false;
    }
}

class TooltipCollection {
    constructor(group) {
        this.group = group;
        this.collection = [];
        this.overlay;
        
        this.init();
        this.listen();
    }

    init() {
        this.group.forEach(element => {
            this.collection.push( new Tooltip(element) );
        });
    }

    listen() {
        jQuery(document).on('syn_tooltip:close', this.closeAll.bind(this));
    }

    closeAll() {
        this.collection.forEach(tooltip => {
            tooltip.deactivate();
        });
    }
}

export { Tooltip, TooltipCollection };